import { logError } from 'setup/logger/logError';

export type Id = string | number | null | undefined;

export function compareObjectIds(a: Id, b: Id, context?: string): boolean {
  if (a == null && b == null) {
    logError(
      `compareObjectIds: both ids are nullish ${context ? ` (${context})` : ''}`,
      { a, b }
    );
    return false;
  }
  if (a == null || b == null) {
    logError(
      `compareObjectIds: one id is nullish ${context ? ` (${context})` : ''}`,
      { a, b }
    );
    return false;
  }
  if (typeof a !== typeof b) {
    logError(
      `compareObjectIds: different types ${context ? ` (${context})` : ''}`,
      { a, b }
    );
    return false;
  }
  return a === b;
}
